import { render } from "./SearchBar.vue?vue&type=template&id=1ce9f128&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"

import "./SearchBar.vue?vue&type=style&index=0&id=1ce9f128&lang=sass&scoped=true"

import exportComponent from "/opt/build/repo/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce9f128"]])

export default __exports__